import { AlertCircle, Phone } from '@untitled-ui/icons-react';
import React, { useEffect, useState } from 'react';

import { Button, Modal, Spinner } from '@myhealth-raccoon/components';

import { useClinicSelector, usePatientHasDetails } from 'src/hooks/useAsyncSelector';

type Props = {
    onSuccess(): void;
    onCancel(): void;
};

export function OutstandingBillingCheck({ onSuccess, onCancel }: Props) {
    const { data: patientHasDetails, isLoading: loadingPatientHasDetails } = usePatientHasDetails();
    const { data: clinic } = useClinicSelector();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (patientHasDetails) {
            if (patientHasDetails.outstandingBalance === false) {
                onSuccess();
            } else {
                setIsOpen(true);
            }
        }
    }, [onSuccess, patientHasDetails]);

    return (
        <>
            {loadingPatientHasDetails && <Spinner className="fixed inset-1/2" />}
            <Modal
                open={isOpen}
                afterClose={onCancel}
                onClose={() => setIsOpen(false)}
                icon={{ icon: AlertCircle }}
                title="Please note"
                size="md"
            >
                There is an outstanding account on this profile at the clinic. Please contact the clinic to book your
                appointment.
                <div className="mt-4 flex w-full flex-row gap-4">
                    <Button type="button" onClick={() => setIsOpen(false)} className="flex-1" color="gray">
                        Close
                    </Button>
                    <Button className="flex-1 text-center" href={`tel:${clinic?.phoneNumber}`}>
                        <Phone className="mr-1.5 inline-block size-5" />
                        Contact clinic
                    </Button>
                </div>
            </Modal>
        </>
    );
}
